"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MobileNav = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _enums = require("./enums");
var _golfToEid = _interopRequireDefault(require("@gd-internal/golf-to-eid"));
var _link = _interopRequireDefault(require("@ux/link"));
var _button = _interopRequireDefault(require("@ux/button"));
var _ripOut = _interopRequireDefault(require("rip-out"));
var _subnavPanel = _interopRequireDefault(require("./subnav-panel"));
var _reactMintl = require("@godaddy/react-mintl");
var _chevronDown = _interopRequireDefault(require("@ux/icon/chevron-down"));
var _chevronRight = _interopRequireDefault(require("@ux/icon/chevron-right"));
var _chevronLeft = _interopRequireDefault(require("@ux/icon/chevron-left"));
var _home = _interopRequireDefault(require("@ux/icon/home"));
var _user = _interopRequireDefault(require("@ux/icon/user"));
var _x = _interopRequireDefault(require("@ux/icon/x"));
var _help = _interopRequireDefault(require("@ux/icon/help"));
var _hamburger = _interopRequireDefault(require("@ux/icon/hamburger"));
var _phone = _interopRequireDefault(require("@ux/icon/phone"));
var _classnames = _interopRequireDefault(require("classnames"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
class MobileNav extends _react.Component {
  constructor() {
    super(...arguments);
    this.state = {
      selectedItem: null,
      displaySubNavPanel: false,
      open: false,
      runway: false,
      hideOnScroll: false
    };
    this.html = {};
    this.close = this.close.bind(this);
    this.goToMainMenu = this.goToMainMenu.bind(this);
    this.toggleOpen = this.toggleOpen.bind(this);
    this.killRunway = this.killRunway.bind(this);
  }
  componentDidUpdate() {
    const {
      state
    } = this;
    let subMenuHeight = '';
    if (this.subNavPanel && this.subNavPanel.element) {
      subMenuHeight = this.subNavPanel.element.clientHeight;
    }
    const fauxScreenHeight = screen.height - 60;
    if (subMenuHeight && subMenuHeight > fauxScreenHeight && !state.runway && state.displaySubNavPanel && !state.hideOnScroll) {
      this.setState({
        runway: true
      });
    } else if (!state.displaySubNavPanel && state.runway) {
      this.setState({
        runway: false
      });
    }
  }

  /**
   * close the menu by setting state.open to be false
   *
   * @private
   */
  close() {
    this.props.onClick(false);
    this.setState({
      open: false,
      runway: false,
      displaySubNavPanel: false,
      selectedItem: null
    });
    const html = this.html;
    html.className = (0, _classnames.default)({
      ['mobile-menu-open']: false
    }) || '';
  }

  /**
   * get rid of the runway
   *
   * @private
   */
  killRunway() {
    if (!this.state.runway) {
      return;
    }
    this.setState({
      runway: false,
      hideOnScroll: true
    });
  }

  /**
   * click function to set open/close state of menu
   *
   * @private
   */
  toggleOpen() {
    const {
      open
    } = this.state;
    this.props.onClick(!open);
    this.setState({
      open: !open
    });
  }

  /**
   * click function to set which nav item is selected
   * as well as whether to display the main headings or the subnav
   *
   * @param {Object} item The item that was just clicked on
   * @param {Object} event The click event
   * @private
   */
  onHeadingClick(item, event) {
    if (item.onClick) {
      item.onClick(event);
    }
    this.setState({
      selectedItem: item,
      displaySubNavPanel: true
    });
  }

  /**
   * handles clicking on navigation items with an onClick handler
   *
   * @param {Object} item The item that was just clicked on
   * @param {Object} event The click event
   * @private
   */
  onItemClick(item, event) {
    item.onClick(event);
    this.close();
  }

  /**
   * click function to go back to the main menu
   *
   * @private
   */
  goToMainMenu() {
    this.setState({
      displaySubNavPanel: false,
      hideOnScroll: false
    });
  }

  /**
   * Render a uxcore2 icon
   * @param {string} icon The classname for a uxcore2 icon
   * @returns {React.Element} A span with an icon
   * @private
   */
  renderIcon(icon) {
    if (icon) {
      return /*#__PURE__*/_react.default.createElement("span", {
        className: (0, _classnames.default)(icon, 'uxicon', 'custom-icon')
      });
    }
    return null;
  }

  /**
   * Render a heading that is a plain button with no children.
   * @param  {Object} item A navigation item that contains link data
   * @param {Number} idx The index at which the item appears in the nav array
   * @param  {String} eid Eid for click tracking
   * @param  {Boolean} active If the parent is active
   * @returns {ReactElement} Div containing a parent link
   */
  renderPlainButton(item, idx, eid, active) {
    const {
      urlArgs,
      useGradientHighlightBar
    } = this.props;
    const {
      caption,
      title,
      icon,
      id,
      href,
      dataAttrs,
      target,
      onClick
    } = item;
    const plainButton = /*#__PURE__*/_react.default.createElement(_link.default, (0, _extends2.default)({
      key: (caption || id) + idx,
      className: (0, _classnames.default)('column-heading', {
        active
      }),
      href: href,
      urlArgs: urlArgs,
      "data-eid": eid,
      target: target,
      onClick: onClick && this.onItemClick.bind(this, item),
      onClicked: this.close
    }, dataAttrs), title || caption, this.renderIcon(icon));
    if (!useGradientHighlightBar) {
      return plainButton;
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "column-container"
    }, active && /*#__PURE__*/_react.default.createElement("div", {
      className: "column-highlight",
      role: "presentation"
    }, ' '), plainButton);
  }

  /**
   * Render a heading button that has children
   * @param  {Object} item A parent navigation item that has children
   * @param {Number} idx The index at which the item appears in the nav array
   * @param  {String} eid Eid used for click tracking
   * @param  {Boolean} active If the parent is active
   * @returns {ReactElement} Div containing a parent that has children
   */
  renderHeadingWithChildren(item, idx, eid, active) {
    const {
      caption,
      title,
      id
    } = item;
    const menuItem = /*#__PURE__*/_react.default.createElement("div", {
      key: (caption || id) + idx,
      className: (0, _classnames.default)('column-heading', {
        active
      }),
      onClick: this.onHeadingClick.bind(this, item),
      "data-eid": eid
    }, title || caption, this.renderIcon(item.icon), /*#__PURE__*/_react.default.createElement("span", {
      className: "menu-arrow-left"
    }, /*#__PURE__*/_react.default.createElement(_chevronRight.default, {
      width: 16,
      height: 16
    })));
    if (!this.props.useGradientHighlightBar) {
      return menuItem;
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "column-container"
    }, active && /*#__PURE__*/_react.default.createElement("div", {
      className: "column-highlight",
      role: "presentation"
    }, ' '), menuItem);
  }

  /**
   * render top level headings for nav
   *
   * @private
   * @returns {ReactElement} a set of divs
   */
  renderMobileHeadings() {
    const props = this.props;

    // eslint-disable-next-line complexity
    return props.nav.map((item, idx) => {
      if (item.desktopOnly) {
        return null;
      }
      const {
        caption,
        title,
        id,
        children,
        href
      } = item;
      if (caption || title) {
        const active = props.activeHeading && (props.activeHeading.caption && caption === props.activeHeading.caption || props.activeHeading.id && id === props.activeHeading.id);
        const eid = item.eid || (0, _golfToEid.default)(caption || id || '', {
          prefix: props.eidPrefix,
          postfix: 'link.click'
        });

        // add a divider above partner programs
        if (props.growthnav2 && id === 'Sales:ProductNav:PartnerPrograms') {
          let content;
          if (children && children.length > 0) {
            content = this.renderHeadingWithChildren(item, idx, eid, active);
          } else if (href) {
            content = this.renderPlainButton(item, idx, eid, active);
          }
          return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
            key: id + idx
          }, /*#__PURE__*/_react.default.createElement("hr", null), content);
        }
        if (children && children.length > 0) {
          return this.renderHeadingWithChildren(item, idx, eid, active);
        } else if (href) {
          return this.renderPlainButton(item, idx, eid, active);
        }
      }
    }).filter(menuItem => menuItem != null);
  }

  /**
   * render gray header with close button
   * and conditionally a back button
   *
   * @param {Boolean} showBackBtn Whether or not to show the back button
   * @private
   * @returns {ReactElement} a div for the top header
   */
  renderTopContainer(showBackBtn) {
    const {
      props
    } = this;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "mobile-top-container"
    }, showBackBtn && /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this.goToMainMenu,
      className: "main-menu-btn",
      text: this.props.menuTitle,
      icon: /*#__PURE__*/_react.default.createElement(_chevronLeft.default, {
        width: 12,
        height: 12
      })
    }), !showBackBtn && props.showMenuTitleOnHome && /*#__PURE__*/_react.default.createElement("div", {
      className: "mobile-top-container-label"
    }, this.props.menuTitle), /*#__PURE__*/_react.default.createElement("span", {
      onClick: this.close,
      className: "close-button"
    }, /*#__PURE__*/_react.default.createElement(_x.default, {
      width: 24,
      height: 24
    })));
  }

  /**
   * Render array of all panels containing subnavs
   *
   * @private
   *
   * @returns {Array} div of SubNavPanels
   */
  renderSubNavPanels() {
    const {
      state,
      props
    } = this;
    const panels = [];
    const {
      selectedItem
    } = state;
    const {
      caption,
      title
    } = selectedItem || {};
    props.nav.forEach((navItem, i) => {
      if (navItem.desktopOnly) {
        return;
      }
      if (navItem.children) {
        const open = state.displaySubNavPanel && (caption && caption === navItem.caption || title && title === navItem.title);
        panels.push( /*#__PURE__*/_react.default.createElement(_subnavPanel.default, {
          onClose: this.close,
          onBack: this.goToMainMenu,
          open: open,
          navigation: navItem,
          menuTitle: props.menuTitle,
          eidPrefix: props.eidPrefix,
          currentHref: props.currentHref,
          urlArgs: props.urlArgs,
          key: 'subNavPanel' + i,
          ref: r => {
            if (open) {
              this.subNavPanel = r;
            }
          }
        }));
      }
    });
    return panels;
  }

  /**
   * Render panel displaying nav headings if navigation menu is open
   *
   * @private
   *
   * @returns {ReactElement} div for the nav headings
   */
  renderHeadingsPanel() {
    const {
      state,
      props
    } = this;
    if (typeof document !== 'undefined') {
      const userAgent = window.navigator.userAgent;
      const iOS = userAgent.match(/iPhone|iPad/i); // iPad and iPhone user agent for Safari
      const mobileRegExp = /(iPad|iPhone).*WebKit(?:(?!(CriOS|FxiOS|OPiOS)).)*$/;
      const mobileSafariClass = mobileRegExp.test(userAgent) ? `mobile-safari-${iOS[0].toLowerCase()}` : '';
      const html = this.html = this.target || document.documentElement;

      // dedupe the 'mobile-menu-open'
      let openMenuClass = '';
      if (state.open && !html.className.includes('mobile-menu-open')) {
        openMenuClass = {
          ['mobile-menu-open']: true
        };
      }
      html.className = (0, _classnames.default)(html.className, mobileSafariClass, openMenuClass);
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)('headings-panel', {
        open: !state.displaySubNavPanel && state.open
      })
    }, this.renderTopContainer(), /*#__PURE__*/_react.default.createElement("div", {
      className: "mobile-wrap"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "mobile-label"
    }, props.menuTitle), this.renderMobileHeadings()));
  }

  /**
   * Render panel displaying mobile nav buttons if navigation menu is open
   *
   * @private
   *
   * @returns {ReactElement} list of buttons
   */
  renderButtons() {
    const {
      state
    } = this;
    let props = this.props;
    props = (0, _ripOut.default)(props, 'ariaLabel');
    let leftIcon = /*#__PURE__*/_react.default.createElement("span", {
      "aria-hidden": "true"
    }, /*#__PURE__*/_react.default.createElement(_phone.default, {
      width: 24,
      height: 24
    }));
    let leftHref = props.urls.contactUs && props.urls.contactUs.href;
    let leftA11y = props.messages[_enums.golf.callUs];
    let leftEid = _enums.eids.callUs;
    if (props.showHomeLink) {
      leftIcon = /*#__PURE__*/_react.default.createElement("span", {
        "aria-hidden": "true"
      }, /*#__PURE__*/_react.default.createElement(_home.default, {
        width: 24,
        height: 24
      }));
      if (props.privateLabelId === 1) {
        if (props.isInGoCohort) {
          leftHref = props.urls.accountHome && props.urls.accountHome.href;
          leftEid = 'uxp.hyd.mobile_nav.account_home.link.click';
        } else {
          leftHref = props.urls.products && props.urls.products.href;
          leftEid = 'uxp.hyd.mobile_nav.my_products.link.click';
        }
      } else {
        leftHref = props.urls.home && props.urls.home.href;
        leftEid = 'uxp.hyd.mobile_nav.home.link.click';
      }
      leftA11y = '';
    }
    return /*#__PURE__*/_react.default.createElement("ul", {
      className: (0, _classnames.default)('mobile-buttons', {
        closed: !state.open || state.displaySubNavPanel
      })
    }, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_link.default, {
      ariaLabel: leftA11y,
      href: leftHref || '#',
      "data-eid": leftEid
    }, leftIcon)), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_link.default, {
      ariaLabel: props.messages[_enums.golf.myAccount],
      href: props.urls.account && props.urls.account.href || '#',
      "data-eid": _enums.eids.myAccount
    }, /*#__PURE__*/_react.default.createElement("span", {
      "aria-hidden": "true"
    }, /*#__PURE__*/_react.default.createElement(_user.default, {
      width: 24,
      height: 24
    })))), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_link.default, {
      ariaLabel: props.messages[_enums.golf.help],
      href: props.urls.help && props.urls.help.href || '#',
      "data-eid": _enums.eids.help
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "icon-help",
      "aria-hidden": "true"
    }, /*#__PURE__*/_react.default.createElement(_help.default, {
      width: 24,
      height: 24
    })))));
  }

  /**
   * Render translucent background behind the navigation menu
   *
   * @private
   *
   * @returns {ReactElement} div for the background
   */
  renderBackground() {
    if (!this.state.open) {
      return null;
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      onClick: this.close,
      className: "mobile-bkg"
    });
  }

  /**
   * Render main button with aria-label
   *
   * @param {String} ariaLabel Text for aria-label
   * @private
   * @returns {ReactElement} a main button
   */
  getButton(ariaLabel) {
    const {
      props
    } = this;
    let buttonTitle;
    if (props.useActiveHeadingAsMenuTitle && props.activeHeading) {
      if (props.activeHeading.caption) {
        buttonTitle = props.activeHeading.caption;
      } else if (props.activeHeading.title) {
        buttonTitle = props.activeHeading.title;
      }
    }
    if (!buttonTitle) {
      buttonTitle = props.menuTitle;
    }
    const trayName = /*#__PURE__*/_react.default.createElement("span", {
      className: "mobile-tray-name"
    }, props.showTitle && buttonTitle);
    return /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      onClick: this.toggleOpen,
      className: "nav-container btn",
      "aria-label": ariaLabel,
      "data-eid": props.menuButtonEid
    }, props.privateLabelId !== 1 && /*#__PURE__*/_react.default.createElement("span", {
      className: "hamburger-icon"
    }, /*#__PURE__*/_react.default.createElement(_hamburger.default, {
      width: 24,
      height: 24
    })), trayName);
  }
  render() {
    const {
      props,
      state
    } = this;
    return /*#__PURE__*/_react.default.createElement(_reactMintl.IntlProvider, {
      locale: props.market,
      messages: props.messages
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(props.className, 'mobile-top-menu-item')
    }, typeof props.menuTitleAriaLabel !== 'undefined' && this.getButton(props.menuTitleAriaLabel), typeof props.menuTitleAriaLabel === 'undefined' && /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: _enums.golf.mainMenu
    }, text => this.getButton(text)), this.renderBackground(), /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)('mobile-navigation', {
        open: state.open
      }),
      onScroll: this.killRunway
    }, this.renderHeadingsPanel(), props.showButtons && this.renderButtons(), this.renderSubNavPanels(), /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)('runway-container', {
        show: state.runway
      })
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "icon-chev-down-lt"
    }, /*#__PURE__*/_react.default.createElement(_chevronDown.default, {
      width: 24,
      height: 24
    })), /*#__PURE__*/_react.default.createElement("span", {
      className: "icon-chev-down-lt"
    }, /*#__PURE__*/_react.default.createElement(_chevronDown.default, {
      width: 24,
      height: 24
    })), /*#__PURE__*/_react.default.createElement("span", {
      className: "icon-chev-down-lt"
    }, /*#__PURE__*/_react.default.createElement(_chevronDown.default, {
      width: 24,
      height: 24
    }))))));
  }
}
exports.MobileNav = MobileNav;
MobileNav.propTypes = {
  activeHeading: _propTypes.default.object,
  className: _propTypes.default.string,
  currentHref: _propTypes.default.string.isRequired,
  eidPrefix: _propTypes.default.string,
  growthnav2: _propTypes.default.bool,
  isInGoCohort: _propTypes.default.bool,
  market: _propTypes.default.string.isRequired,
  menuTitleAriaLabel: _propTypes.default.string,
  messages: _propTypes.default.object.isRequired,
  nav: _propTypes.default.arrayOf(_propTypes.default.object).isRequired,
  menuButtonEid: _propTypes.default.string,
  menuTitle: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object, _propTypes.default.instanceOf(_reactMintl.FormattedMessage)]),
  onClick: _propTypes.default.func,
  privateLabelId: _propTypes.default.number,
  showButtons: _propTypes.default.bool,
  showHomeLink: _propTypes.default.bool,
  showMenuTitleOnHome: _propTypes.default.bool,
  showTitle: _propTypes.default.bool,
  urlArgs: _propTypes.default.object,
  urls: _propTypes.default.object.isRequired,
  useActiveHeadingAsMenuTitle: _propTypes.default.bool,
  useGradientHighlightBar: _propTypes.default.bool
};

/**
 * Default property values.
 *
 * @type {Object}
 * @public
 */
MobileNav.defaultProps = {
  currentHref: '',
  eidPrefix: 'uxp.hyd.mobile_nav',
  growthnav2: false,
  menuTitle: /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: "Shared:MobileNav:MainMenu"
  }),
  market: 'en-US',
  onClick: () => {},
  showButtons: true,
  showHomeLink: false,
  showMenuTitleOnHome: false,
  showTitle: true,
  useActiveHeadingAsMenuTitle: false,
  useGradientHighlightBar: false
};
var _default = MobileNav;
exports.default = _default;